import React from 'react';
import { useAppSelector } from '../store/hooks';

interface AuthenticatedProps {
  children?: React.ReactNode;
  className?: string;
}

// Renders its children only when the user is authenticated.
const Authenticated = ({ children, className }: AuthenticatedProps) => {
  // store is typed (RootState); store.auth.isAuthenticated is a boolean.
  const isAuthenticated = useAppSelector((store) => store.auth.isAuthenticated);

  if (!isAuthenticated) {
    return null;
  }

  return children instanceof Array
    ? <div className={className}>{children}</div>
    : <>{children}</>;
};

export default Authenticated;
